import { detectCloseElement } from "./helper";

export const product = {
	filterOption: function () {
		$("body").on("click", ".product-filter-category .filter-title", function () {
			const $this = $(this);
			$this.toggleClass("active");
			$(this).next(".filter-content").slideToggle();
		});
	},
	cart: function () {
		$(".mini-cart-wrapper .close").on("click", function (e) {
			e.stopPropagation();
			$(".mini-cart-wrapper").removeClass("isOpen");
		});
		$("body").on("click", ".header-cart .icon-cart", function () {
			$(".mini-cart-wrapper").toggleClass("isOpen");
		});
		detectCloseElement(".header-cart", "icon-cart", () => {
			$(".mini-cart-wrapper").removeClass("isOpen");
		});
		if (window.matchMedia("(max-width: 767.98px)").matches) {
			$(".mini-cart-wrapper").appendTo("main");
		}
	},
	filterSidebar: function () {
		const $button = $(".btn-filter-product");
		const $close = $(".product-filter-category .close");
		if (window.matchMedia("(max-width: 1279.98px)").matches) {
			$button.on("click", function () {
				$(".product-filter-category").addClass("isOpen");
			});
			//
			$close.on("click", function () {
				$(".product-filter-category").removeClass("isOpen");
			});
		} else {
			$button.on("click", function () {
				$(this).toggleClass("active");
				$("body").toggleClass("isCloseSidebar");
			});
		}
	},
	addFrame: function () {
		const img = $(".item-image-preview").find("img");
		const input = $('input[name="frame"]');
		const addValue = (value) => {
			img.css("border-image-source", `url(${value})`);
		};
		input.on("change", function () {
			const value = $(this).val();
			addValue(value);
		});
	},
	addEdge: function () {
		const img = $(".item-image-preview");
		const imgClassInit = img.attr("class");
		const input = $('input[name="edge"]');
		const addClassInit = () => {
			img.attr("class", imgClassInit);
		};
		input.on("change", function () {
			const value = $(this).val();
			if (value) {
				addClassInit();
				img.addClass(value);
			} else {
				addClassInit();
			}
		});
	},
	search: function () {
		let debounceTimer;
		$("input.search-field").on("input", function () {
			const $this = $(this);
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(function () {
				const searchTerm = $this.val();
				$.ajax({
					url: "/wp-admin/admin-ajax.php", // This variable is defined by WordPress and contains the URL to admin-ajax.php
					type: "POST",
					dataType: "html",
					data: {
						action: "get_product_by_search",
						keyword: searchTerm,
					},
					beforeSend: function (data) {
						$(".header-search-form").addClass("isLoading");
					},
					success: function (data) {
						$(".wrap-list-search-product").css("display", "block");
						if (data) {
							$(".wrap-list-search-product .product-search-matching-keyword-tpn").html(data);
						} else {
							$(".wrap-list-search-product .product-search-matching-keyword-tpn").html('<div class="no-product p-5">Không có sản phẩm phù hợp</div>');
						}
						$(".header-search-form").removeClass("isLoading");
						observer.observe();
					},
					completed: function (data) {},
				});
				// Perform search operation using the searchTerm
			}, 300); // Adjust the debounce time as per your requirement
		});
	},
	filterMockup: function () {},
	popupMockup: function () {
		const $box = $(".box-discover-frame");
		const $popup = $("#popup-image-mockup");
		$("body").on("click", ".box-discover-frame .slide-mockup button", function () {
			const isSelected = $box.find(".wrap-select-room select").val();
			const index = $(this).data("index");
			$popup.find("select").val(isSelected);
			Fancybox.show([{ src: "#popup-image-mockup", type: "inline", showClass: "popup-product" }]);
			popupMockup.init();
			popupMockupThumb.init();
			popupMockup.slideTo(index-1);
		});
	},
	draggable: function () {
		$(".box-discover-frame .wrap-inputs input").on("change", function () {
			if (Number($(this).val()) > 100) {
				$(this).val(100);
			}
			const nameInput = $(this).attr("name");
			const nameValue = $(this).val();
			$(".img-preview-mockup .mask").css(`--mask-${nameInput}`, nameValue + "%");
		});
	},
	init: function () {
		product.filterOption();
		product.filterSidebar();
		product.addFrame();
		product.addEdge();
		product.cart();
		product.search();
		product.popupMockup();
		product.draggable();
	},
};
